import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadConfig } from './utils/configLoader';
// import { ProductsProvider } from './ProductsContext';
import { ProductsProvider } from './Components/ProductsContext'; // Import the ProductsProvider
import { CartProvider } from './Components/CartContext';
import { BaseUrlProvider } from './Components/BaseUrlContext';
import "./Components/i18n"
import { LanguageProvider } from './Components/LanguageContext';
import { CompaniesProvider } from './Components/CompaniesContext';

import { UserContext, UserProvider } from './Components/UserContext';

// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// Load config before rendering app
const initializeApp = async () => {
  await loadConfig();
  
  const root = ReactDOM.createRoot(document.getElementById('root'));
  
  const AppWrapper = (
    <UserProvider>
      <LanguageProvider>
        <BaseUrlProvider>
          <ProductsProvider>
            <CartProvider>
              <CompaniesProvider>
                <App />
              </CompaniesProvider>
            </CartProvider>
          </ProductsProvider>
        </BaseUrlProvider>
      </LanguageProvider>
    </UserProvider>
  );
  
  // Only use StrictMode in development for better performance in production
  root.render(
    process.env.NODE_ENV === 'development' ? (
      <React.StrictMode>{AppWrapper}</React.StrictMode>
    ) : (
      AppWrapper
    )
  );
};

initializeApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
